module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.value), function(tag, idx) {
    return _c('el-tag', {
      key: idx,
      attrs: {
        "type": "primary",
        "closable": !_vm._readonly,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (!_vm._readonly) ? _c('el-input', {
    staticClass: "input-new-tag",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.spec.placeholder
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-474ac62c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-tags.vue
// module id = 519
// module chunks = 55